// Intakall installs as a desktop Chrome extension, so "phone" here means any
// device that cannot install one: phones, tablets, and in-app browsers.

export interface DeviceInfo {
  userAgent: string;
  maxTouchPoints?: number;
}

const MOBILE_UA = /iPhone|iPad|iPod|Android|Mobile/i;

export function isPhone({ userAgent, maxTouchPoints = 0 }: DeviceInfo): boolean {
  if (MOBILE_UA.test(userAgent)) return true;
  // iPadOS requests the desktop site and reports itself as a Mac. A Mac has no
  // touchscreen, so a "Mac" with touch points is an iPad.
  return /Macintosh/.test(userAgent) && maxTouchPoints > 1;
}
